// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--80d6d";
export var footerLinksWrapper = "footer-module--footerLinksWrapper--6807a";